import ButtonSpinner from "./ButtonSpinner";

const COLOR_CLASSES = {
  purple: "bg-main-purple hover:bg-indigo-600 focus-visible:outline-indigo-600",
  red: "bg-red-600 hover:bg-red-500 focus-visible:outline-red-600",
  green: "bg-green-600 hover:bg-green-500 focus-visible:outline-green-600",
  blue: "bg-blue-600 hover:bg-blue-500 focus-visible:outline-blue-600",
};

export default function ActionButton({
  color = "purple",
  children,
  className = "",
  loading = false,
  disabled = false,
  ...props
}) {
  const colorClasses = COLOR_CLASSES[color] || COLOR_CLASSES.purple;

  return (
    <button
      className={`inline-flex min-w-[80px] justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${colorClasses} ${className}`.trim()}
      disabled={loading || disabled}
      {...props}
    >
      <ButtonSpinner spin={loading} text={children} />
    </button>
  );
}
